import { Box, CardMedia, CircularProgress, Icon, Skeleton, Typography } from '@mui/material'
import { useEffect, useState } from 'react'
import Tags from './Tags'
import DrawerHeaderButtonState from './DrawerHeaderButtonState'
import InterviewTag from './InterviewTag'
import { useMutation, useQueryClient } from 'react-query'
import { updateCandidate } from 'services/api/modules/recruitment/external-talent'
import EditDetailsModal from '../../recruitment-external-talent/components/EditDetailsModal'
// import { StarRateRounded } from '@mui/icons-material'

const HeaderDetailsDrawer = ({
  id,
  applicantName = 'insert name',
  price = '123.45',
  date,
  data,
  job_fit,
  IntersectionObserverRef,
  paid,
  loading,
  mappedData,
  handleDrawerClose,
  changeApplicantDetail,
  has_video,
  profile_picture,
  application_status,
  in_cart,
  email,
  name,
  contactNumber,
  candidate_id,
  interview_data,
  profile_score,
  application_type,
  has_resume,
  profile_type,
}) => {
  // set for when the status of the applicant in the drawer change, the data at the drawer list change
  const [initialLength, setInitialLength] = useState(mappedData.length)
  const [isDataChange, setIsDataChange] = useState(false)
  const [arrayChanged, setArrayChanged] = useState(false)

  /**
   * START HERE
   *
   * This fixes the issue where the applicant list detail does not
   * update after rejecting or shortlisting. The quick fix is to
   * add another dependency `arrayChanged`. A thorough test hasn't
   * been done yet, bugs are expected. The entire code implementation
   * requires a major revamp. :(
   *
   * */

  useEffect(() => {
    if (isDataChange) {
      if (mappedData.length > 0) {
        changeApplicantDetail(mappedData[0])
      } else {
        handleDrawerClose('right', false)
      }
      setIsDataChange(false)
      setArrayChanged(true)
    }
  }, [mappedData, isDataChange, changeApplicantDetail, handleDrawerClose])

  useEffect(() => {
    if (arrayChanged && mappedData.length !== initialLength) {
      if (mappedData.length > 0) {
        changeApplicantDetail(mappedData[0])
      } else {
        handleDrawerClose('right', false)
      }
      setInitialLength(mappedData.length)
      setArrayChanged(false)
    }
  }, [
    arrayChanged,
    changeApplicantDetail,
    handleDrawerClose,
    initialLength,
    mappedData,
    mappedData.length,
  ])

  /**
   *END HERE
   * */

  // change date format
  const newDate = new Date(date)
  const formattedDate = newDate.toLocaleDateString('en-GB', {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
    hour12: true,
  })

  //edit detail (name,email,contact number ONLY for job_type===resume)
  const queryClient = useQueryClient()
  const [open, setOpen] = useState(false)
  const defaultValues = {
    name: name ? name : '',
    email: email ? email : '',
    contact: contactNumber ? contactNumber : '',
  }
  const [talentDetails, setTalentDetails] = useState(defaultValues)

  const handleToggle = () => {
    setOpen((prevOpen) => !prevOpen)
    setTalentDetails({
      name: name ? name : '',
      email: email ? email : '',
      phone: contactNumber ? contactNumber : '',
    })
  }
  // api to edit detail
  const { mutate: editDetails, error: updateError } = useMutation(
    (data) => updateCandidate(candidate_id, data),
    {
      onSuccess: () => {
        queryClient.invalidateQueries('getCandidate')
        queryClient.invalidateQueries('getAllCandidate')
        queryClient.invalidateQueries('getAllApplicant')
        queryClient.invalidateQueries('getApplicantDetail')
        setOpen(false)
      },
      onError: (error) => {
        console.error(error)
      },
    }
  )

  if (loading) {
    return (
      <Box>
        <Box>
          {/* tags for interview candidate only */}
          {application_status === 'interview' && (
            <InterviewTag id={id} interviewId={interview_data?.id} />
          )}

          <Box px={'30px'} marginTop={2} display="flex" columnGap={2} flexDirection="column">
            <Box display="flex" columnGap={2}>
              <Box>
                <Skeleton variant="circular" width={'65px'} height={'65px'} />
              </Box>
              <Box
                sx={{
                  width: '100%',
                  overflow: 'hidden',
                }}
              >
                <Typography
                  variant="h3"
                  color="dark-text.main"
                  sx={{
                    textTransform: 'capitalize',
                    wordWrap: 'break-word',
                    maxWidth: '90%',
                  }}
                >
                  <Skeleton variant="text" width={'80%'} />
                </Typography>

                <Box display="flex" columnGap={1} mb={2}>
                  <Skeleton variant="text" width={'40%'} />
                </Box>

                <Box
                  display="flex"
                  columnGap={1}
                  justifyContent="space-between"
                  sx={{
                    width: '98%',
                  }}
                >
                  <Skeleton variant="rounded" width={'50%'} height={45} />
                  <Skeleton variant="rounded" width={'50%'} height={45} />
                </Box>

                {application_type === 'self apply' && (
                  <Typography marginTop={1} variant="body1" color="light-gray-text.main">
                    <Skeleton variant="text" width={'40%'} />
                  </Typography>
                )}
              </Box>
            </Box>
          </Box>
        </Box>
      </Box>
    )
  } else {
    return (
      <>
        <Box>
          <Box
            ref={IntersectionObserverRef}
            // marginTop={10}
          >
            {/* tags for interview candidate only */}
            {application_status === 'interview' && (
              <InterviewTag id={id} interviewId={interview_data?.id} />
            )}

            <Box px={'30px'} marginTop={2} display="flex" columnGap={2} flexDirection="column">
              <Box display="flex" columnGap={2}>
                {/* Lock profile picture if candidate has not been purchased */}
                {!paid ? (
                  <Box>
                    <Box
                      display="flex"
                      justifyContent="center"
                      alignItems="center"
                      width={'65px'}
                      height={'65px'}
                      bgcolor="gray-background.main"
                      color="white.main"
                      borderRadius="50%"
                    >
                      <Icon
                        sx={{
                          color: 'light-gray-text.main',
                        }}
                      >
                        locked
                      </Icon>
                    </Box>
                  </Box>
                ) : (
                  <Box>
                    {/* display profile picture if candidate is purchased  */}
                    {profile_picture !== null ? (
                      <CardMedia
                        component="img"
                        sx={{
                          marginRight: 2,
                          height: '65px',
                          width: '65px',
                          objectFit: 'cover',
                          borderRadius: '50%',
                        }}
                        src={profile_picture}
                      />
                    ) : application_type === 'matched by candidate recommender' ? (
                      // show person icon if candidate is from external source
                      <Box
                        width={'65px'}
                        height={'65px'}
                        borderRadius="50%"
                        bgcolor="gray-background.main"
                        marginRight={2}
                        display="flex"
                        alignItems="center"
                        justifyContent="center"
                      >
                        <Icon
                          sx={{
                            color: 'light-gray-text.main',
                          }}
                        >
                          person_outline_outlined
                        </Icon>
                      </Box>
                    ) : (
                      //  {/* display name if candidate is purchase but profile picture is not available and not an external candidate*/}

                      <Box
                        display="flex"
                        justifyContent="center"
                        alignItems="center"
                        width={'65px'}
                        height={'65px'}
                        bgcolor="alternate.main"
                        color="white.main"
                        borderRadius="50%"
                        sx={{
                          textTransform: 'capitalize',
                        }}
                      >
                        {applicantName?.charAt(0)}
                      </Box>
                    )}
                  </Box>
                )}

                <Box
                  sx={{
                    width: '100%',
                    overflow: 'hidden',
                  }}
                >
                  {profile_type === 'resume' ? (
                    <Box
                      onClick={handleToggle}
                      sx={{
                        color: 'transparent',
                        display: 'flex',
                        gap: '8px',
                        alignItems: 'center',
                        cursor: 'pointer',
                        '&:hover': { color: 'alternate.main' },
                      }}
                    >
                      <Typography
                        variant="h3"
                        sx={{
                          textTransform: 'capitalize',
                          wordWrap: 'break-word',
                          maxWidth: '90%',
                          color: 'dark-text.main',
                          '&:hover': { color: 'alternate.main' },
                        }}
                      >
                        {applicantName || id}
                      </Typography>

                      <Icon sx={{ fontSize: '16px' }}>edit</Icon>
                    </Box>
                  ) : (
                    <Typography
                      variant="h3"
                      color="dark-text.main"
                      sx={{
                        textTransform: 'capitalize',
                        wordWrap: 'break-word',
                        maxWidth: '90%',
                      }}
                    >
                      {applicantName || id}
                    </Typography>
                  )}

                  <Box display="flex" columnGap={1} mb={2}>
                    {/* <Box display="flex" alignItems="center" justifyContent="center" marginRight={0.5}>
                    <StarRateRounded color="yellow-01" fontSize="small" />
                      <Typography variant="subtitle1" paddingTop={0.3}>
                        {job_fit?.overall_match_score ? job_fit?.overall_match_score : '1'}
                      </Typography>
                    </Box> */}
                    {has_resume && <Tags icon="article" word="Resume" />}
                    {has_video && <Tags icon="video_file" word="Video interview" />}
                  </Box>

                  {/* TODO TEMPORORRAY REMOVEEEEDED FOR PTIHING  */}
                  {/* {!paid && (
                  <Typography marginTop={4} variant="h3" color="dark-text.main">
                    RM {price}.00
                  </Typography>
                )} */}

                  {/* BUTTON SECTION */}
                  {/*status for pending review (matched/applied)*/}
                  {application_status === 'pending review' ? (
                    //status for matched/applied and paid
                    paid ? (
                      <DrawerHeaderButtonState
                        id={id}
                        type="shortlist"
                        email={email}
                        mappedData={mappedData}
                        handleDrawerClose={handleDrawerClose}
                        setIsDataChange={setIsDataChange}
                      />
                    ) : //status for matched/applied but not paid, so check if in cart or not
                    in_cart ? (
                      <DrawerHeaderButtonState
                        id={id}
                        type="view in cart"
                        mappedData={mappedData}
                        handleDrawerClose={handleDrawerClose}
                        setIsDataChange={setIsDataChange}
                      />
                    ) : (
                      <DrawerHeaderButtonState
                        id={id}
                        type="add to cart"
                        mappedData={mappedData}
                        handleDrawerClose={handleDrawerClose}
                      />
                    )
                  ) : null}

                  {/* status for shorlisted */}
                  {application_status === 'shortlisted' && (
                    <DrawerHeaderButtonState
                      id={id}
                      type="schedule interview"
                      mappedData={mappedData}
                      handleDrawerClose={handleDrawerClose}
                      applicantName={applicantName}
                      email={email}
                      candidate_id={candidate_id}
                      profile_type={profile_type}
                      profile_picture={profile_picture}
                      setIsDataChange={setIsDataChange}
                    />
                  )}

                  {/* status for interview */}
                  {application_status === 'interview' && (
                    <DrawerHeaderButtonState
                      id={id}
                      type="offer"
                      mappedData={mappedData}
                      handleDrawerClose={handleDrawerClose}
                      setIsDataChange={setIsDataChange}
                    />
                  )}
                  {/* status for offer */}
                  {application_status === 'offered' && (
                    <DrawerHeaderButtonState
                      id={id}
                      setIsDataChange={setIsDataChange}
                      type="move to hired"
                    />
                  )}
                  {/* status for hired */}
                  {application_status === 'hired' && (
                    <DrawerHeaderButtonState
                      setIsDataChange={setIsDataChange}
                      id={id}
                      type="hired"
                    />
                  )}
                  {/* status for rejected */}
                  {application_status === 'rejected' && (
                    <DrawerHeaderButtonState
                      setIsDataChange={setIsDataChange}
                      id={id}
                      type="rejected"
                    />
                  )}

                  {application_type === 'self apply' && (
                    <Typography marginTop={1} variant="body1" color="light-gray-text.main">
                      Applied on {formattedDate}
                    </Typography>
                  )}
                </Box>
              </Box>
            </Box>
          </Box>
        </Box>
        <EditDetailsModal
          error={updateError}
          editDetails={editDetails}
          talentId={candidate_id}
          defaultValues={defaultValues}
          open={open}
          talentDetails={talentDetails}
          setTalentDetails={setTalentDetails}
          handleToggle={handleToggle}
        />
      </>
    )
  }
}
export default HeaderDetailsDrawer
